import $ from "jquery";

$(() => {
  const menu_sections = $('.header .menu').children();
  const menu_info_sections = $('.header .menu-section-info');
  const $searchForm = $('.header .search-form');
  const $searchButton = $('.header .search-button-desktop');
  const $searchClose = $('.header .search-close-desktop');
  const $main = $('main');

  if (menu_sections.length) {
    menu_sections.each((i, menu_section) => {
      $(menu_section).addClass('menu-section');
      const $sub_menu = $(menu_section).children('.sub-menu');

      if( $sub_menu.children('li').children('.sub-menu').length > 0) {
        $sub_menu.addClass('sub-menu-has-children');
      }

      if(menu_info_sections.length) {
        menu_info_sections.each((i, menu_info_section) => {
          if($(menu_info_section).hasClass(menu_section.innerText.toLowerCase())) {
            $(menu_info_section).prependTo($sub_menu);
          }
        })
      }

      $(menu_section).on('click', function(e) {
        e.preventDefault();
        const $target = $('body');
        if($(menu_section).hasClass('active--section')) {
          $target.removeClass('menu--section--active');
          $(menu_section).removeClass('active--section');
        } else {
          $('.header .active--section').removeClass('active--section');
          $target.addClass('menu--section--active');
          $(menu_section).addClass('active--section');
        }
        $target.removeClass('menu--search--active');
      })

      $sub_menu.on('click', function(e) {
        e.stopPropagation();
      })
    })
  }

  $('.header #hamburger').on('click', function(e) {
    e.preventDefault();
    const $target =  $('body');
    if( $target.hasClass('menu--active')) {
      $target.removeClass('menu--search--active');
    }
    $target.toggleClass('menu--active');
  });

  $('.header .close-button').on('click', function(e) {
    e.preventDefault();
    const $target = $('body');
    if( $target.hasClass('menu--search--active')) {
      $target.removeClass('menu--search--active');
    } else {
      $target.removeClass('menu--active');
      $target.removeClass('menu--section--active');
      $('.header .active--section').removeClass('active--section');
    }
  });

  $main.on('click', () => {
    const $target = $('body');
    if($target.hasClass('menu--active')) {
      $target.removeClass('menu--active');
      $('.header .active--section').removeClass('active--section');
    }
    if($target.hasClass('menu--section--active')) {
      $target.removeClass('menu--section--active');
      $('.header .active--section').removeClass('active--section');
    }
    if($target.hasClass('menu--search--active')) {
      $target.removeClass('menu--search--active');
    }
  })

  $('.header .back-button').on('click', function(e) {
    e.preventDefault();
    const $target = $('body');
    if( $target.hasClass('menu--search--active')) {
      $target.removeClass('menu--search--active');
    } else {
      $target.removeClass('menu--section--active');
      $('.header .active--section').removeClass('active--section');
    }
  });

  $(window).resize(function() {
    const $target =  $('body');
    $target.removeClass('menu--active');
    $target.removeClass('menu--section--active');
    $target.removeClass('menu--search--active');
    $('.header .active--section').removeClass('active--section');
    $('.is-ajax-search-result').css("display", "");
  })

  $searchForm.on('click', () => {
    const $target = $('body');
    // console.log('search form click');
    $target.addClass('menu--search--active');
  })

  $searchButton.on('click', () => {
    const $target = $('body');
    $target.toggleClass('menu--search--active');
    $target.removeClass('menu--section--active');
    $(menu_sections).removeClass('active--section');
  })

  $searchClose.on('click', (e) => {
    e.stopPropagation();
    const $target = $('body');
    $target.removeClass('menu--search--active');
  })
});